window.addEventListener("load", function () {
    
    setearUsuario = function(usuario_id, estatus){

        if(estatus == 1)
        {
          document.getElementById('txt_mensaje').innerHTML = 'Esta acción cambiará el estatus del usuario a inactivo y ya no podrá iniciar sesión en la plataforma. <br><br>¿Desea continuar?';
        }
        else
        {
          document.getElementById('txt_mensaje').innerHTML = 'Esta acción activará nuevamente al usuario, permitiéndole ingresar nuevamente a la plataforma y desarrollar las actividades acorde a su rol <br><br>¿Desea continuar?<strong>';
        }
    
        document.getElementById('estatus').value = estatus;
        document.getElementById('usuario_id').value = usuario_id;
    }

    cambiarEstatus = function(){
        const estatus    = document.getElementById('estatus').value;
        const usuario_id = document.getElementById('usuario_id').value;
    
        const myModalEl = document.getElementById('estatusUsuarioModal');
        const modal = bootstrap.Modal.getInstance(myModalEl);
    
        let control = '';
        let mensaje = '';
    
        if(!estatus || !usuario_id)
        {
          return false;
        }
    
        let formData = new FormData();
        formData.append("estatus", estatus);
        formData.append("usuario_id", usuario_id);
    
        axios
          .post(`${base_url}/admin/usuarios/cambiarEstatus`, formData)
          .then(function (response) {
    
            if (response.data.success == true) 
            {
              if(estatus == 1)
              {
                control = `<a href="" class="text-decoration-none" data-bs-toggle="modal" data-bs-target="#estatusUsuarioModal" onclick="setearUsuario(${usuario_id}, 0)"><img src="${base_url}/images/icons/inactivo.svg" alt=""> <strong class="text-danger">Inactivo</strong></a>`;
              }
              else
              {
                control = `<a href="" class="text-decoration-none" data-bs-toggle="modal" data-bs-target="#estatusUsuarioModal" onclick="setearUsuario(${usuario_id}, 1)"><img src="${base_url}/images/icons/activo.svg" alt=""> <strong class="text-success">Activo</strong></a>`;
              }
    
              document.getElementById(`estatus_${usuario_id}`).innerHTML = control;
    
              mensaje = ` <div class="alert alert-success alert-dismissible fade show" role="alert">
                              <strong>¡Éxito!</strong> El estatus se modifico correctamente
                              <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                          </div>`;
            }
            else
            {
              mensaje = `  <div class="alert alert-danger alert-dismissible fade show" role="alert">
                                <img src="${base_url}/images/icons/alert-error.svg"/>
                                <strong>Error: </strong>
                                Error al cambiar el estatus
                                <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                            </div>`;
            }
    
            document.querySelector('.alerta').innerHTML = mensaje;
          })
          .catch(function (response) {
            console.log(response);
    
            mensaje = `  <div class="alert alert-danger alert-dismissible fade show" role="alert">
                                <img src="${base_url}/images/icons/alert-error.svg"/>
                                <strong>Error: </strong>
                                Error desconocido
                                <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                            </div>`;
            document.querySelector('.alerta').innerHTML = mensaje;
          });
    
          modal.hide();
      }
});